import React, { createContext, useContext, useEffect, useState } from 'react';
import pageService from '../services/PageService';
import IPagePreview from '../models/page/IPagePreview';

type PagePreviewContextType = {
    pageMeta: IPagePreview[];
    isLoading: boolean;
};

const PagePreviewContext = createContext<PagePreviewContextType>({
    pageMeta: [],
    isLoading: true,
});

export const usePageMeta = () => useContext(PagePreviewContext);

export const PagePreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [pageMeta, setPageMeta] = useState<IPagePreview[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        pageService.getPagePreviews()
            .then((pages) => {
                setPageMeta(pages);
                setIsLoading(false);
            })
            .catch(() => setIsLoading(false));
    }, []);

    return (
        <PagePreviewContext.Provider value={{ pageMeta, isLoading }}>
            {children}
        </PagePreviewContext.Provider>
    );
};